import { useLockDate } from "@api/lock.api";
import { isLockedByDateOnly } from "@helpers/lock";

export function useIsDateLocked(
    entityId: number | null,
    dateOnly?: string | null,
) {
    const lockDate = useLockDate(entityId);
    return isLockedByDateOnly(lockDate, dateOnly);
}
